function setCustomTime(dateTimeString, timeString) {
  if (!dateTimeString || typeof dateTimeString !== 'string') return false;
  if (!timeString || typeof timeString !== 'string') return false;
  const timeParts = timeString.split(':');
  if (timeParts.length !== 2) return false;
  const [hours, minutes] = timeParts.map(Number);
  if (Number.isNaN(hours) || Number.isNaN(minutes)) return false;
  const date = new Date(dateTimeString);
  date.setHours(hours);
  date.setMinutes(minutes);
  date.setSeconds(0);
  date.setMilliseconds(0);
  return date.toISOString();
}

export default setCustomTime;
